/**
 * Anchor Select2 dropdowns to their own field wrapper instead of <body>.
 *
 * Select2 appends the dropdown to <body> and positions it by subtracting the
 * offset parent's offset from the field's document offset. Third-party tags can
 * turn <body> into the scroll container with `position: relative` — Qualified's
 * docked panel (js.qualified.com/docking.js) does exactly this, site-wide, once
 * cookie consent is accepted:
 *
 *   html { height: 100dvh !important; overflow: hidden !important;
 *          position: relative !important; contain: inline-size layout !important }
 *   body { height: 100% !important; overflow: hidden auto !important;
 *          position: relative !important }
 *
 * With <body> scrolling, jQuery's body.offset().top returns the scroll position
 * rather than 0, so Select2 subtracts it from a coordinate that is already in
 * body's content space and places every dropdown exactly scrollY pixels too
 * high. The dropdown opens correctly in every other respect — it is simply
 * painted off-screen — so it reads as "the dropdowns don't work" once you have
 * scrolled past the top of the page.
 *
 * Passing dropdownParent keeps the maths off <body> entirely. Select2 falls back
 * to offsetParent() when the parent is static, which would land back on <body>,
 * so the wrapper is positioned first.
 */

const PATCHED_FLAG = 'mriDropdownParentPatched';

function patchSelect2(jq) {
  if (!jq || !jq.fn || typeof jq.fn.select2 !== 'function' || jq.fn.select2[PATCHED_FLAG]) {
    return;
  }

  const original = jq.fn.select2;

  function select2WithLocalDropdown(options) {
    // Method calls ('destroy', 'open', 'val', …) and explicit dropdownParent
    // options are none of our business.
    if (!jq.isPlainObject(options) || options.dropdownParent) {
      return original.apply(this, arguments);
    }

    this.each(function () {
      const $el = jq(this);
      const $parent = $el.parent();

      if (!$parent.length) {
        original.call($el, options);
        return;
      }

      if ($parent.css('position') === 'static') {
        $parent.css('position', 'relative');
      }

      original.call($el, jq.extend({}, options, { dropdownParent: $parent }));
    });

    return this;
  }

  // Carry over .amd, .defaults and friends, which callers reach through directly.
  jq.extend(select2WithLocalDropdown, original);
  select2WithLocalDropdown[PATCHED_FLAG] = true;

  jq.fn.select2 = select2WithLocalDropdown;
}

// Select2 is registered by a plugin script (ProfilePress ships 4.0.13), so patch
// as soon as it is there and again on ready — NitroPack rewrites script order on
// the front end and the plugin bundle is not guaranteed to have run yet.
patchSelect2(window.jQuery);
jQuery(document).ready(() => patchSelect2(window.jQuery));



// WEBPACK FOOTER //
// ./scripts/autoload/_select2-dropdown-parent.js